import { render, staticRenderFns } from "./Accidentinvolved.vue?vue&type=template&id=0c2ac5d4&scoped=true&"
import script from "./Accidentinvolved.vue?vue&type=script&lang=js&"
export * from "./Accidentinvolved.vue?vue&type=script&lang=js&"
import style0 from "./Accidentinvolved.vue?vue&type=style&index=0&id=0c2ac5d4&lange=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ac5d4",
  null
  
)

export default component.exports